import { faDownload, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Nav, Navbar } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import InquiryFormModal from "../common_components/InquiryFormModal/InquiryFormModal";
import "./Header.css";

function Header() {
  const navigate = useNavigate();
  const location = useLocation();

  const pathname = location.pathname;

  const [expanded, setExpanded] = useState(false);
  const [modalshow, setmodalshow] = useState(false);
  const [activeSection, setActiveSection] = useState("home");

  // ----------------------------------
  // Navigate to normal page
  // ----------------------------------
  const handleNavClick = (path) => {
    navigate(path);
    setExpanded(false);
  };

  // ----------------------------------
  // Scroll to section
  // ----------------------------------
  const handleSectionClick = (sectionId) => {
    setExpanded(false);

    if (sectionId === "home") {
      if (pathname === "/") {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      } else {
        navigate("/");
      }
      return;
    }

    if (pathname === "/") {
      const section = document.getElementById(sectionId);

      if (section) {
        section.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }

      return;
    }

    navigate(`/?section=${sectionId}`);
  };

  // ----------------------------------
  // Handle section query after navigation
  // ----------------------------------
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const sectionId = params.get("section");

    if (!sectionId || pathname !== "/") return;

    const timer = setTimeout(() => {
      const section = document.getElementById(sectionId);

      if (section) {
        section.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [pathname, location.search]);

  // ----------------------------------
  // Contact modal
  // ----------------------------------
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const modal = params.get("modal");

    if (modal === "contact-us") {
      setmodalshow(true);
    }
  }, [pathname, location.search]);

  // ----------------------------------
  // Detect active section while scrolling
  // ----------------------------------
  useEffect(() => {
    if (pathname !== "/") {
      setActiveSection("");
      return;
    }

    const sections = document.querySelectorAll("section[id]");

    if (!sections.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const visibleSections = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio);

        if (visibleSections.length > 0) {
          setActiveSection(visibleSections[0].target.id);
        }
      },
      {
        root: null,
        rootMargin: "-100px 0px -50% 0px",
        threshold: [0.1, 0.25, 0.5, 0.75],
      },
    );

    sections.forEach((section) => observer.observe(section));

    return () => {
      sections.forEach((section) => observer.unobserve(section));
    };
  }, [pathname]);

  // ----------------------------------
  // Open brochure modal
  // ----------------------------------
  const openModal = () => {
    setmodalshow(true);
    setExpanded(false);
  };

  return (
    <section className="main_head">
      <div className="inquirybtndiv">
        <a href="tel:+919607755557" className="inquirybtn">
          <span>
            <FontAwesomeIcon icon={faPhone} style={{ color: "#fff" }} />
          </span>
          CALL US
        </a>

        <button type="button" className="inquirybtn" onClick={openModal}>
          <span>
            <FontAwesomeIcon icon={faDownload} style={{ color: "#fff" }} />
          </span>
          DOWNLOAD BROCHURE
        </button>
      </div>

      <div className="container-md">
        <Navbar
          expand="md"
          className="main_navbar p-0"
          expanded={expanded}
          onToggle={(value) => setExpanded(value)}
        >
          <Navbar.Brand>
            <div className="logodiv" onClick={() => handleSectionClick("home")}>
              <img
                src="/assets/images/header/logo.png"
                alt="Logo"
                className="logo_img"
              />
            </div>
          </Navbar.Brand>

          <div className="mobile_logo_holder_2">
            <img
              src="/assets/images/header/right-head-logo.png"
              alt="Logo"
              className="logo_img new_logo"
            />

            <div className="number_class">
              <span>
                <FontAwesomeIcon icon={faPhone} style={{ color: "#fff" }} />
              </span>

              <a href="tel:+919607755557">+91 9607755557</a>
            </div>
          </div>

          <Navbar.Toggle />

          <Navbar.Collapse>
            <div className="links_holder">
              <div className="links_div">
                <Nav className="nav_links">
                  <Nav.Link
                    onClick={() => handleSectionClick("home")}
                    className={activeSection === "home" ? "active" : ""}
                  >
                    Home
                  </Nav.Link>

                  <Nav.Link
                    onClick={() => handleSectionClick("specialization")}
                    className={
                      activeSection === "specialization" ? "active" : ""
                    }
                  >
                    Specialization
                  </Nav.Link>

                  <Nav.Link
                    onClick={() => handleSectionClick("programs")}
                    className={activeSection === "programs" ? "active" : ""}
                  >
                    Programs
                  </Nav.Link>

                  <Nav.Link
                    onClick={() => handleSectionClick("admissions")}
                    className={activeSection === "admissions" ? "active" : ""}
                  >
                    Admissions
                  </Nav.Link>

                  <Nav.Link
                    onClick={() => handleSectionClick("eligibility")}
                    className={activeSection === "eligibility" ? "active" : ""}
                  >
                    Eligibility
                  </Nav.Link>
                </Nav>
              </div>
            </div>

            <div className="desk_logo_holder_2">
              <img
                src="/assets/images/header/right-head-logo.png"
                alt="Logo"
                className="right_logo d-none"
              />

              <div className="number_class">
                <span>
                  <FontAwesomeIcon icon={faPhone} style={{ color: "#fff" }} />
                </span>

                <a href="tel:+919607755557">+91 9607755557</a>
              </div>
            </div>
          </Navbar.Collapse>
        </Navbar>
      </div>

      <InquiryFormModal
        show={modalshow}
        onHide={() => {
          setmodalshow(false);
          setExpanded(false);
        }}
        setmodalshow={setmodalshow}
        modalshow={modalshow}
      />
    </section>
  );
}

export default Header;
